export default "<div class=\"crear-finca-paso4-map-mount\" id=\"registroFincaPaso4MapMount\"></div>\n"